(()=>{
  const getSidebar=()=>document.querySelector('.facest-filters-section .m-sidebar');
  const setPanelOpen=open=>{
    const sidebar=getSidebar();
    if(!sidebar)return;
    const content=sidebar.querySelector('.m-sidebar--content');
    const section=sidebar.closest('.facest-filters-section');
    if(open){
      sidebar.style.display='block';
      requestAnimationFrame(()=>{
        sidebar.style.setProperty('--m-bg-opacity','0.5');
        content?.style.setProperty('--m-translate-x','0');
      });
      section?.classList.add('sidebar-open');
      document.documentElement.style.overflow='hidden';
    }else{
      section?.classList.remove('sidebar-open');
      content?.style.setProperty('--m-translate-x','-100%');
      sidebar.style.removeProperty('--m-bg-opacity');
      document.documentElement.style.removeProperty('overflow');
      setTimeout(()=>sidebar.style.removeProperty('display'),300);
    }
    document.querySelectorAll('.m-sidebar--open').forEach(button=>button.setAttribute('aria-expanded',open?'true':'false'));
  };

  document.addEventListener('input',event=>{
    if(!(event.target instanceof Element)||!event.target.matches('[data-luminex-filter-search]'))return;
    const query=event.target.value.trim().toLocaleLowerCase();
    document.querySelectorAll('.m-collection-filters-form [data-luminex-filter]').forEach(group=>{
      const items=[...group.querySelectorAll('.m-facet--item')];
      if(!items.length){
        group.style.display=query?'none':'';
        return;
      }
      let visible=0;
      items.forEach(item=>{
        const show=!query||item.textContent.toLocaleLowerCase().includes(query);
        item.style.display=show?'':'none';
        if(show)visible++;
      });
      group.style.display=visible?'':'none';
    });
  });

  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const quick=event.target.closest('[data-luminex-quick-param]');
    if(quick){
      event.preventDefault();
      const url=new URL(location.href);
      const param=quick.dataset.luminexQuickParam;
      const value=quick.dataset.luminexQuickValue;
      if(url.searchParams.getAll(param).includes(value)){
        url.searchParams.delete(param);
      }else if(param==='sort_by'){
        url.searchParams.set(param,value);
      }else{
        url.searchParams.append(param,value);
      }
      url.searchParams.delete('page');
      location.href=url.toString();
      return;
    }

    const openButton=event.target.closest('.m-sidebar--open');
    const closeButton=event.target.closest('.m-sidebar--close');
    const sidebar=getSidebar();
    if(!sidebar||(!openButton&&!closeButton&&event.target!==sidebar))return;
    event.preventDefault();
    event.stopImmediatePropagation();
    setPanelOpen(Boolean(openButton));
  },true);

  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&document.querySelector('.facest-filters-section.sidebar-open')){
      setPanelOpen(false);
    }
  });
})();
